import React from 'react';

import { Alert } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    em {
        text-transform: uppercase;
        font-style: normal;
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
    }
`;

const StyledIcon = styled(NwIcon)`
    font-size: ${(props) => props.theme.FontSizeBase};
    color: ${(props) => props.theme.TextColorMuted};
    .fa-primary {
        fill: #fff;
        opacity: 1;
    }
    .fa-secondary {
        fill: ${(props) => props.theme.PrimaryColor};
        opacity: 1;
    }
`;

const ModelsConfirmedInfo = ({ style }) => (
    <Wrapper style={style}>
        <StyledIcon icon={byPrefixAndName.fasds['circle-info']} />
        <em>Models in bold are confirmed in at least a workdate</em>
    </Wrapper>
);

export default ModelsConfirmedInfo;
